var map = {
	"./499.png": "36a2",
	"./bancor 20@2x.png": "9336",
	"./bancor.png": "7498",
	"./benziga.png": "2e33",
	"./cision.png": "7159",
	"./coinpost.png": "dfec",
	"./coinpost@2x.png": "85eb",
	"./finanzen.png": "7dfb",
	"./hackernoon.png": "c59a",
	"./landlordzone.png": "21fb",
	"./market-watch.png": "80a6",
	"./newsbtc.png": "e9df",
	"./toutiao.png": "6bd8",
	"./toutiao@2x.png": "a13d",
	"./yahoo-finance.png": "0570"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "78ea";